import actions from '../../actionTypes';

export default (area, ignoreFile) => {
  return {
    type: actions.EXPAND_AREA,
    area,
    ignoreFile
  };
};



// WEBPACK FOOTER //
// ./src/reducers/areas/actions/areaExpand.js